import { Component, Vue } from 'vue-property-decorator';
import * as MemberApiController from '../api/MemberApiController';
import { RegisterMemberModel } from '../api/viewmodels/RegisterMemberModel';

@Component
export default class CreateAccount extends Vue {

    newPassword: string = '';
    newPasswordConfirm: string = '';
    passwordResetAlerts: string[] = [];

    showAlert: boolean = false;
    alertText: string = '';
    alertColor: string = '';

    loading: boolean = false;

    submitPasswordChange() {
        this.showAlert = false;

        this.passwordResetAlerts = [];
        var hasErrors: boolean = false;
        if (this.newPassword == '') {
            this.passwordResetAlerts.push("Vul een wachtwoord in");
            hasErrors = true;
        }

        if (this.newPassword != '' && this.newPassword.length < 10) {
            this.passwordResetAlerts.push("Uw wachtwoord moet minimaal 10 tekens lang zijn");
            hasErrors = true;
        }

        if (this.newPassword != '' && this.newPassword.length > 255) {
            this.passwordResetAlerts.push("Uw wachtwoord mag maximaal 255 tekens lang zijn");
            hasErrors = true;
        }

        if (this.newPasswordConfirm == '') {
            this.passwordResetAlerts.push("Bevestig uw wachtwoord");
            hasErrors = true;
        }

        if (this.newPassword !== this.newPasswordConfirm) {            
            this.passwordResetAlerts.push("De opgegeven wachtwoorden zijn niet gelijk.")
            hasErrors = true;
        }

        if (hasErrors) {
            this.showAlert = true;
            this.alertColor = "error";
            return;
        }

        var model: RegisterMemberModel = {
            guid: <string>this.$route.query.guid,
            confirmPassword: this.newPasswordConfirm,
            password: this.newPassword
        };
        MemberApiController.register(model)
            .then((response) => {
                if (response.data.success) {
                    this.passwordResetAlerts.push("Uw wachtwoord is aangepast. U kunt nu inloggen met het nieuwe wachtwoord.");
                    this.showAlert = true;
                    this.alertColor = "success";
                }
                else {
                    this.passwordResetAlerts.push("Het wachtwoord kon niet aangepast worden. Probeer het nog eens.");
                    this.showAlert = true;
                    this.alertColor = "error";
                }
            })
            .catch((error) => {
                this.passwordResetAlerts.push("Het wachtwoord kon niet aangepast worden. Probeer het nog eens.");
                this.showAlert = true;
                this.alertColor = "error";
            });
    }
}
